export default __webpack_public_path__ + "static/media/Sonu.24d20f25.jpg";